import type { Bounds2d, Point2d } from "."

export const findMinMaxPoints = (
  ...nodes: Point2d[]
): {
  min: Point2d
  max: Point2d
} => {
  const bounds = nodes.reduce<Bounds2d>(
    (acc, { x, y }) => ({
      y: {
        top: Math.min(acc.y.top, y),
        bottom: Math.max(acc.y.bottom, y),
      },
      x: {
        left: Math.min(acc.x.left, x),
        right: Math.max(acc.x.right, x),
      },
    }),
    {
      y: { top: Infinity, bottom: 0 },
      x: { left: Infinity, right: 0 },
    },
  )

  return {
    min: { x: bounds.x.left, y: bounds.y.top },
    max: { x: bounds.x.right, y: bounds.y.bottom },
  }
}
